import * as bootstrap from 'bootstrap';
import { escapeHtml } from 'df-helpers/dist/escape-html';
import { useEffect } from 'react';
import { ReactModel } from '../../react-model/react-model';

let g_seq_id = 1;
/**
 * Parameters
 * * model.getState()[field] - if is not empty, then it is the error message
 * * element_ref is the input element
 * * props is the attributes that will be written to the element
 *
 * Actions
 * * if error found, then set class "is-invalid", and display popup only when focused
 * * otherwise, set class "is-valid"
 *
 * Returns
 * `props` is returned. If frozen, then it is re-created.
 *
 */
export function useValidator<T>(model: ReactModel<T>, field: keyof T, element_ref: { current: HTMLElement | null }, props: React.HTMLAttributes<any>, no_popover?: boolean) {
	var validator = model.validator();
	validator?.useModel();
	if (validator) {
		if (Object.isFrozen(props)) props = { ...props };
		const error_str = validator.getState()[field];
		if (model.validator()?.isEnabled(field)) {
			if (error_str) {
				props.className += ' is-invalid ';
			} else props.className += ' is-valid ';
		}
		if (!no_popover) {
			//popover events
			props.onFocus = (e) => {
				const pop = bootstrap.Popover.getInstance(element_ref!.current as any);
				if (pop && error_str) {
					pop.show();
					updateText(pop, error_str);
				}
			};
			props.onBlur = (e) => {
				bootstrap.Popover.getInstance(element_ref!.current as any)?.hide();
			};

			const _useEffect = useEffect;
			_useEffect(() => {
				let pop = bootstrap.Popover.getInstance(element_ref!.current as any);
				if (error_str) {
					let is_new = false;
					if (!pop) {
						is_new = true;
						const unique_class_id = `rm_val_${++g_seq_id}`; //getSeqId('validator');
						pop = new bootstrap.Popover(element_ref!.current as any, {
							placement: 'top',
							customClass: 'validation-popover ' + unique_class_id,
							title: 'Hint',
							content: ' ',
							animation: true,
							trigger: 'manual',
						});
						saveClassId(pop, unique_class_id);
					}
					//calling setContent will cause flicking.
					// pop.setContent({ '.popover-body': error_str || '', '.popover-header': 'Error' });
					if (element_ref.current === document.activeElement && is_new) {
						pop.show();
					}
					updateText(pop, error_str);
				} else {
					pop?.dispose();
					pop = null;
				}
			}, [error_str]);

			//destroy when unmounted
			_useEffect(() => {
				return () => {
					const pop = bootstrap.Popover.getInstance(element_ref!.current as any);
					pop?.dispose();
				};
			}, []);
		}
	}
	return props;
}

function updateText(pop: any, text: string) {
	if (text) {
		text = escapeHtml(text);
		const unique_class_id = (pop as any).unique_class_id as string;
		const item = document
			.getElementsByClassName('validation-popover ' + unique_class_id)?.[0]
			?.getElementsByClassName('popover-body')?.[0];
		if(item){
			item.innerHTML = text;
		}
		// $('.validation-popover.' + unique_class_id + ' .popover-body').text(text);
	}
}
function saveClassId(pop: any, unique_class_id: string) {
	(pop as any).unique_class_id = unique_class_id;
}
